import React from "react";
import {ReactComponent as DeleteIcon} from '../assets/icons/delete.svg';
import './SidebarContainer.scss';
import {showSnackbar} from '../utils/snackbar';
import { connect } from "react-redux";
import {setPageDetails, savePageOnReview, getPages, setPageData, handleDropAction, createPageCopy, removePage,enableLayering, setProjectError } from "../actions/wizard";
import { RedCheckbox } from "components/Checkbox";
 class SidebarContainer extends React.Component<any, any>{
    [x: string]: any;
    
    dragStart(e, pageNumber) {
        try {
            this.dragged = e.currentTarget;
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.dragged);
        } catch (error) {
            console.error("Error in dragStart",error);
        }
    }
    dragEnd(e) {
        try {
            var from = Number(this.dragged.getAttribute('data-id'));
            if(this.over && this.over.classList.contains('page-name-span')){
                this.over = this.over.closest('.sidebar-item');
            }
            var to = Number(this.over.getAttribute('data-id'));    
            console.log("from:"+from+"to:"+to)
            const fromPage = this.props?.pages[from-1];
            const toPage = this.props?.pages[to-1];
            if((fromPage && fromPage?.type === "instruction") || (toPage && toPage?.type === "instruction")){
                showSnackbar("Cannot rearrange instruction page");
                return;
            }
            this.props.handleDropAction({ from, to })
        } catch (error) {
            console.error("Error in dragOver",error);
        }
    }
    dragOver(e) {
        e.preventDefault();
        this.over = e.target;
    }
    savePageOnReview = (selectedPageNum, isReviewed)=>{
        try {
            let {pageDetails, projectData} = this.props;
            let {pageNumber} = pageDetails;
            let {opportunityId, roomDetails} = projectData;
            let projectId = `${opportunityId}`, roomId = Object.keys(roomDetails)[0];
            let data ={
                projectId,
                roomId,
                page:pageDetails
            };
            if(!pageDetails.reviewed && pageDetails['isOptional']){
                this.props.setProjectError({ error: "A Page Cannot Be Marked Both Reviewed And Unwanted At Same Time,Please Mark Page Either Reviewed or Unwanted" });
                return
            }
            if(pageDetails.reviewed){
                pageDetails.reviewed = false;
            }else{
                pageDetails.reviewed = true;
            }
            let emptyFields = [];
            let pageValues = pageDetails?.carcaseDetails || pageDetails?.shutterDetails || {};
            let pageKeys = Object.keys(pageValues) || [];
            if(pageNumber !== selectedPageNum)
                return;
            pageKeys.map(key =>{
                if(key !== 'heading'){
                    if(Array.isArray(pageValues[key])){
                        if(pageValues[key] && !pageValues[key].length)
                            emptyFields.push(key);
                    }
                    let objKeys = Object.keys(pageValues[key]) || [];
                    objKeys.map(objkey=>{
                            if(objkey !== 'heading'){
                            if(pageValues[key][objkey]){
                                let val = pageValues[key][objkey]['value'] ? pageValues[key][objkey]['value'].toString(): ""
                                if(!val)
                                    emptyFields.push(pageValues[key]['heading']);

                            }
                        }
                        return objkey;
                    })
                }
                return key;
            })
            console.log("empty fields", emptyFields);
         this.props.savePageOnReview(data);

         //ToDo: Move it in a common place or replace it by snackbar modules 
         if(pageDetails.reviewed){
            showSnackbar("Page Reviewed Successfully!");
         }else{
            showSnackbar("Page Successfully removed from review");
         }

        } catch (error) {
            console.error("Error in savePageOnReview",error);
        }
    }
    copyPage = (selectedPageNum)=>{
        try {
            let {pages, pageDetails} = this.props;
            pageDetails = Object.assign({}, pageDetails);
            let {pageNumber} = pageDetails;
            let index =1;
            (pages || []).map(p=>{
                if(p.type && p.type.indexOf(pageDetails.type) !== -1)
                    index+=1;
                return p;
            })
            pageDetails.pageType = "created_page";
            pageDetails.name = `${pageDetails.name} ${index}`
            pageDetails.pageNumber = pages.length+1;
            if(pageNumber !== selectedPageNum)
                return;
            this.props.createPageCopy({pageNumber: pages.length+1, pageData: Object.assign({},pageDetails)})

            showSnackbar("Page Copied Successfully!");
        } catch (error) {
            console.error("Error in copyPage",error);
        }
    }
    deletePage = (selectedPageNum) =>{
        try {
            let {pageDetails} = this.props;
            let {pageNumber} = pageDetails;
            if(selectedPageNum !== pageNumber)
                return;
            this.props.removePage(pageNumber);

            showSnackbar("Page Deleted Successfully!");
        } catch (error) {
            console.error("Error in deletePage", error);
        }
    }
    handleOptionalIcon = (selectedPageNum, isReviewed)=>{
        try {
            let { pageDetails } = this.props;
            let { pageNumber } = pageDetails;
            if(isReviewed && !pageDetails['isOptional']){
                this.props.setProjectError({ error: "A Page Cannot Be Marked Both Reviewed And Unwanted At Same Time,Please Mark Page Either Reviewed or Unwanted" });
                return
            }
            
            if(selectedPageNum !== pageNumber)
                return;
            pageDetails['isOptional'] =  pageDetails['isOptional'] ? false: true
            this.props.savePageOnReview({page:pageDetails})
            if(pageDetails['isOptional'])
                showSnackbar("Page successfully marked as 'unwanted'");
            else
                showSnackbar("Page is no more 'unwanted'");
        } catch (error) {
            console.error("Error in handleOptionIcon", error)
        }
    }

    onPageClick = (e) => {
        
    }
    
    render(){
        const {width} =this.props;
        const {pages,exportDrawingStatus,previewMode, height ,pageDetails, hideSidebar} = this.props;
        let pageKeys = [];
        const disableMenu = (exportDrawingStatus === 'inprogress'|| previewMode === 'enabled')
        if(pages)
            pageKeys = Object.keys(pages);
        const listItems =  (pageKeys || []).map((key, index)=>{
            let page = pages[key];
            let pageNumber = page.pageNumber || 1;
            const pageClass = pageDetails?.pageNumber === page?.pageNumber? ' sidebar-item selectedPage':'sidebar-item';
            if (hideSidebar) {
                return <div
                    className={`page_no_list ${pageClass}`}
                    onClick={(e) => {
                        this.props.setPageData({ pageNumber: page.pageNumber, reviewed: page.reviewed, pageType: page.pageType, projectData: this.props.projectData })
                    }}
                >{index === 0 ? 1 : index + 1}
                </div>
            }
            return(
                <div key={index}>
                    <li title={`${page?.name?.includes("OLD PAGE")?"Old Pages By Default Will Be Ignored For Export/Preview":""}`} data-id={page.pageNumber} key={index} className={pageClass} draggable="true" onClick={(e)=>{
                        this.props.setPageData({ pageNumber:page.pageNumber, reviewed: page.reviewed, pageType: page.pageType, projectData: this.props.projectData})}} onDragEnd={this.dragEnd.bind(this)} onDragStart={(e)=>this.dragStart(e,page.pageNumber)}><span className={`${ page.name.includes("OLD PAGE")?"page-name-span-deleted":"page-name-span"}`}>{`${index ===0 ? 1: index+1}. ${page.name}`}</span>
                        {
                         <div className="icons">
                            {/* <CopyIcon className="icon-sidebar" onClick={()=> this.copyPage(pageNumber)}/> */}
                            {
                                (page.pageType === 'created_page' || page.name.includes("OLD PAGE"))  ? <DeleteIcon className="icon-sidebar" onClick={(e)=> {this.deletePage(pageNumber);e.stopPropagation()}}/> : ""
                            }   
                            {
                                //page.reviewed ?<Review_green_icon className="review-icon icon-sidebar" onClick = {(e)=> this.savePageOnReview(pageNumber)} /> :<Review_red_icon className="review-icon icon-sidebar" onClick = {(e)=> this.savePageOnReview(pageNumber)}/>
                                !page.name.includes("OLD PAGE") && <RedCheckbox checked={page?.reviewed || false} handleChange = {(e)=> this.savePageOnReview(pageNumber, page?.reviewed)} page={page}/>
                            }
                            {
                                !page.name.includes("OLD PAGE") && <i title={`${page.isOptional?"Remove 'unwanted' tag to get this page in the final PDF export":"Mark as 'unwanted' to skip this page in the final PDF export"}`} 
                                    className={`fa fa-times-circle optionalIcon ${page.isOptional?'optionalIconActive':''} ${['RFQ'].includes(page?.pageType) ? 'toolBarDisabledIcon' : ''}`} 
                                    onClick={(e)=>this.handleOptionalIcon(pageNumber, page?.reviewed)}></i>
                            }
                        </div>
                        }
                        {/*need to add copy page icon */}
                        {/* <span onClick={()=> this.copyPage()}>copy</span> */}
                    </li>
                   
                    {pageDetails?.pageNumber === page?.pageNumber && pageDetails?.type && pageDetails?.sidebarInfo? 
                    <div>
                    {pageDetails?.sidebarInfo?.Elevation?<p className={'subheading'}>Elevation Tips:</p>:null}
                    <ul className='showSidebarInfo fadeinfo'>
                    {   
                        pageDetails?.sidebarInfo?.Elevation?.map(tip=> <li key={tip}>{tip}</li> )
                    }
                    </ul>
                    {pageDetails?.sidebarInfo?.Specification?<p className={'subheading'}>Specification Tips:</p>:null}
                    <ul className='showSidebarInfo fadeinfo'>
                    {   
                       pageDetails?.sidebarInfo?.Specification?.map(tip=> <li key={tip}>{tip}</li>)
                    }
                    </ul>
                    {Array.isArray(pageDetails?.sidebarInfo) ? <ul className='showSidebarInfo fadeinfo'>
                    {   
                         pageDetails?.sidebarInfo?.map(tip=><li key={tip}>{tip}</li>)
                    }
                    </ul>:null}
                    </div>:null}
                   
                </div>
            )
        })    
        return(
            <div style={{width: width, height: height,borderRight:'1px solid lightGray',position:'fixed',overflow:'auto',overflowX:'hidden'}}
                className={`${disableMenu?'disable-click':''}`}>
                <div className="sidebar-ul">
                    <ol className={`sidebar-menus`} onDragOver={e=>this.dragOver(e)}>
                        {listItems}
                    </ol>
                </div>
            </div>
        )
    }

}
export default connect(
    (state: any) => ({
        pageDetails:state.wizard.pageDetails,
        previewMode:state.wizard.previewMode,
        exportDrawingStatus:state.wizard.exportDrawingStatus,
        pages: state.wizard.pages,
        projectData: state.wizard.projectData,
        hideSidebar: state.wizard.hideSidebar,
    }),
    {
        setPageDetails,
        savePageOnReview,
        getPages,
        setPageData,
        handleDropAction,
        createPageCopy,
        removePage,
        enableLayering,
        setProjectError,
    }
)(SidebarContainer);
